export default {"src":"/_next/static/media/assessment.29299ae0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};